import routes from '@/modules/request/request-routes';
import store from '@/modules/request/request-store';

export default {
  routes,
  store,
};
